const moment = require('moment');

const ageFromDateOfBirth = (dateOfBirth) => {
  return moment().diff(moment(dateOfBirth), 'years');
};

const dateOfBirthFromID = (id) => {
  let birthDate = moment(id.slice(0, 6), 'YYMMDD');
  if (birthDate.isSameOrAfter(moment())) {
    birthDate = moment('19' + id.slice(0, 6), 'YYYYMMDD');
  }
  return birthDate;
};

const ageFromID = (idNumber) => {
  const birthDate = dateOfBirthFromID(idNumber);
  const age = moment().diff(birthDate, 'years');
  return age;
};

module.exports = {
  ageFromDateOfBirth,
  ageFromID
};



// WEBPACK FOOTER //
// ./src/helpers/age.js